import request from '@/utils/request'

export function sendUserVerifyCodeApi(data: { email: string }) {
  return request<null>({
    url: 'mailer/sendUserVerifyCode',
    method: 'POST',
    data,
  })
}
